<template>
  <div class="audit-logs-container">
    <h1>Audit Logs - Coming Soon</h1>
  </div>
</template>

<script>
export default {
  name: 'AuditLogs'
}
</script>

<style scoped>
.audit-logs-container {
  padding: 20px;
}
</style>